var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTruck = function SvgTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 925,
    height: 516.83,
    viewBox: "0 0 732 409",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F041B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M88.385 83c7.531-8.753 12.12-20.12 12.12-32.58C100.505 22.817 78.15.443 50.581.443 23.006.444.658 22.818.658 50.42c0 12.459 4.589 23.828 12.12 32.58l37.803 49.464L88.385 83"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.038 398H16.962C7.594 398 0 390.41 0 381.047V16.953C0 7.589 7.594 0 16.962 0h165.076C191.406 0 199 7.59 199 16.953v364.094c0 9.363-7.594 16.953-16.962 16.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M181.833 392H17.167C10.999 392 6 386.997 6 380.825V17.175C6 11.003 11 6 17.167 6h164.666C188.001 6 193 11.003 193 17.175v363.65c0 6.172-5 11.175-11.167 11.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.5 6H59l6.375 10.935C67.208 20.08 70.495 22 74.038 22h50.924c3.544 0 6.83-1.921 8.663-5.065L140 6H99.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M6 344L193 344 193 48 6 48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M129.534 225.942l-49.172 28.51-25.786-44.773 49.162-28.522 25.796 44.785M193 52.59L79.026 118.686 38.319 48H27.043l43.53 75.58L6 161.033v11.303l69.456-40.271 23.398 40.618L6 226.53v11.312l40.111-23.267 25.796 44.773L6 297.574v11.312l70.715-41.01C92.137 296.648 94.253 322.071 94.426 344h9.768c-.174-23.224-2.41-50.202-19.015-81.03l49.239-28.555L193 336.125v-19.57l-50.128-87.045L193 200.444V189.13l-55.011 31.905-22.813-39.596 37.116-21.528-10.875-18.83-37.093 21.517-20.414-35.44L193 63.904V52.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00029A",
    d: "M107 126.5c0 1.933-13.432 3.5-30 3.5-16.568 0-30-1.567-30-3.5s13.432-3.5 30-3.5c16.568 0 30 1.567 30 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M94.416 103.145C97.887 99.102 100 93.85 100 88.091 100 75.338 89.702 65 77 65S54 75.338 54 88.091c0 5.757 2.112 11.01 5.584 15.054L77 126l17.416-22.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M91 87.5c0 7.456-6.044 13.5-13.5 13.5S64 94.956 64 87.5 70.044 74 77.5 74 91 80.044 91 87.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M139.579 233.588c-3.082-.828-5.659-2.813-7.254-5.59L78 133.479l4.697-2.725 54.325 94.521c.87 1.515 2.277 2.597 3.958 3.05 1.68.449 3.438.218 4.945-.658l193.883-112.702c2.763-1.606 5.979-2.035 9.063-1.205 3.082.828 5.658 2.813 7.254 5.59l16.697 29.055c.87 1.515 2.275 2.597 3.957 3.05 1.68.448 3.438.217 4.945-.659l115.54-67.177c2.767-1.606 5.987-2.035 9.065-1.204 3.085.829 5.662 2.814 7.255 5.591l56.33 98.073c.868 1.515 2.272 2.598 3.953 3.05 1.682.452 3.438.22 4.95-.657l42.47-24.687L624 168.5l-42.471 24.687c-2.76 1.606-5.98 2.032-9.065 1.205-3.079-.83-5.655-2.815-7.248-5.591l-56.33-98.073c-.868-1.515-2.272-2.598-3.96-3.051-1.675-.455-3.438-.22-4.943.657l-115.542 67.178c-2.762 1.604-5.98 2.032-9.064 1.205-3.081-.829-5.657-2.814-7.253-5.59l-16.697-29.055c-.87-1.515-2.275-2.599-3.957-3.05-1.684-.454-3.438-.218-4.946.658L148.642 232.383c-1.842 1.07-3.887 1.617-5.959 1.617-1.035 0-2.077-.136-3.104-.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00029A",
    d: "M723 159c0 3.314-25.964 6-58 6s-58-2.686-58-6 25.964-6 58-6 58 2.686 58 6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614 26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M88.385 83c7.531-8.753 12.12-20.12 12.12-32.58C100.505 22.817 78.15.443 50.581.443 23.006.444.658 22.818.658 50.42c0 12.459 4.589 23.828 12.12 32.58l37.803 49.464L88.385 83",
    mask: "url(#prefix__c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M693 75.5c0 15.74-12.758 28.5-28.5 28.5S636 91.24 636 75.5 648.758 47 664.5 47 693 59.76 693 75.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9C1E7",
    d: "M278 403c0 2.762-62.232 5-139 5S0 405.762 0 403c0-2.761 62.232-5 139-5s139 2.239 139 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9D8",
    d: "M732 403c0 2.209-76.558 4-170.996 4C466.559 407 390 405.209 390 403s76.56-4 171.004-4C655.442 399 732 400.791 732 403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C61",
    d: "M493 403c0 3.314-66.708 6-148.999 6-82.29 0-149.001-2.686-149.001-6 0-3.313 66.71-6 149.001-6C426.292 397 493 399.687 493 403"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M351 195c.238 0 .475.005.713.012l7.923-.012c-.153.524-.38 1.008-.665 1.441C368.308 199.935 375 209.385 375 220.5c0 10.663-6.161 19.797-14.908 23.604.402.547.723 1.17.943 1.853l-8.752.006c-.426.023-.854.037-1.283.037-.422 0-.841-.013-1.257-.035h-.008.001C337.07 245.265 327 234.133 327 220.5c0-13.794 10.308-25.028 23.185-25.485v-.001h.046c.255-.009.512-.014.769-.014",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M360 195c13.255 0 24 11.417 24 25.5S373.255 246 360 246c-13.254 0-24-11.417-24-25.5s10.746-25.5 24-25.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91928E",
    d: "M360 206c7.732 0 14 6.716 14 15 0 8.284-6.268 15-14 15s-14-6.716-14-15c0-8.284 6.268-15 14-15",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M228 195c.24 0 .477.005.713.012l7.924-.012c-.154.524-.38 1.008-.665 1.441C245.307 199.935 252 209.385 252 220.5c0 10.663-6.161 19.797-14.907 23.604.402.547.723 1.17.943 1.853l-8.754.006c-.423.023-.851.037-1.282.037-.42 0-.84-.013-1.256-.035h-.007C214.069 245.265 204 234.133 204 220.5c0-13.794 10.308-25.028 23.186-25.485v-.001h.046c.255-.009.51-.014.768-.014",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M237 195c13.254 0 24 11.417 24 25.5S250.254 246 237 246c-13.255 0-24-11.417-24-25.5s10.745-25.5 24-25.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91928E",
    d: "M237 206c7.732 0 14 6.716 14 15 0 8.284-6.268 15-14 15s-14-6.716-14-15c0-8.284 6.268-15 14-15",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040575",
    d: "M216.899 195H421.7c1.043 0 1.561.905 1.169 2.013-.65 1.83-1.294 3.66-1.962 5.488-.667 1.829-1.312 3.66-1.96 5.487-.395 1.108-1.566 2.012-2.587 2.012H216.836c-1.021 0-1.836-.905-1.836-2.012V202.5v-5.488c0-1.107.855-2.013 1.899-2.013",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000357",
    d: "M110.267 0h133.465C244.979 0 246 1.09 246 2.421V196.58c0 1.332-1.02 2.421-2.268 2.421H110.267c-1.246 0-2.267-1.09-2.267-2.421V2.42C108 1.091 109.02 0 110.267 0",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151678",
    d: "M128.316 9h98.815c1.02 0 1.83.871 1.869 1.964v119.59c-12.605-.006-25.21 2.207-37.271 6.627-7.74 2.65-15.126 6.154-22.064 10.411-4.083 1.568-8.06 3.375-11.918 5.408-1.493-.215-2.992-.406-4.487-.608l-2.258-.406c-1.8-.323-3.597-.595-5.39-.824-1.672-.428-3.345-.813-5.02-1.158-1.637-.356-3.275-.714-4.918-1.034l-.004-.013 2.898.52-3.09-1.11c-.452-1.379-.926-2.745-1.42-4.1-.469-2.298-.995-4.569-1.576-6.81l-.246-2.392c-.815-7.905-2.308-15.55-4.396-22.885-.69-4.945-1.643-9.779-2.84-14.487.08-.472.157-.945.231-1.417l.844 2.73V90.67c.327-2.244.64-4.486.94-6.753l.542-3.507c.785-5.075 1.266-10.127 1.47-15.14.574-5.034.862-10.102.862-15.176V29.53c0-6.994-.544-13.85-1.573-20.529",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05084A",
    d: "M241.063 0h190.873C433.621 0 435 1.471 435 3.27v192.46c0 1.799-1.38 3.27-3.064 3.27H241.063c-1.685 0-3.063-1.471-3.063-3.27V3.27C238 1.47 239.378 0 241.063 0",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000357",
    d: "M248.783 9h173.433c1.53 0 2.784 1.331 2.784 2.958v174.084c0 1.628-1.253 2.958-2.784 2.958H248.783c-1.53 0-2.783-1.33-2.783-2.958V11.958C246 10.33 247.252 9 248.783 9l31.556 67.317",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M377.5 193c.273 0 .546.005.818.013l9.078-.013c-.176.597-.436 1.147-.762 1.64C397.331 198.613 405 209.362 405 222c0 12.127-7.06 22.513-17.082 26.844.461.622.83 1.33 1.08 2.107l-10.029.008c-.486.027-.976.041-1.469.041-.483 0-.963-.013-1.44-.04h-.007C361.537 250.165 350 237.505 350 222c0-15.687 11.812-28.462 26.567-28.982v-.002h.053c.293-.009.586-.016.88-.016",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M386.5 193c15.187 0 27.5 12.984 27.5 29s-12.313 29-27.5 29c-15.188 0-27.5-12.984-27.5-29s12.312-29 27.5-29",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E0",
    d: "M387.5 207c8.56 0 15.5 6.939 15.5 15.5s-6.94 15.5-15.5 15.5c-8.56 0-15.5-6.939-15.5-15.5s6.94-15.5 15.5-15.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M386 216c3.315 0 6 2.686 6 6s-2.685 6-6 6c-3.314 0-6-2.686-6-6s2.686-6 6-6",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M259.5 193c.273 0 .547.005.818.013l9.079-.013c-.177.597-.437 1.147-.763 1.64C279.332 198.613 287 209.362 287 222c0 12.127-7.06 22.513-17.081 26.844.46.622.829 1.33 1.08 2.107l-10.03.008c-.486.027-.976.041-1.469.041-.483 0-.962-.013-1.44-.04h-.007C243.537 250.165 232 237.505 232 222c0-15.687 11.812-28.462 26.568-28.982l-.001-.002h.053c.293-.009.586-.016.88-.016",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M267.5 193c15.187 0 27.5 12.984 27.5 29s-12.313 29-27.5 29c-15.188 0-27.5-12.984-27.5-29s12.312-29 27.5-29",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E0",
    d: "M268.5 207c8.56 0 15.5 6.939 15.5 15.5s-6.94 15.5-15.5 15.5c-8.56 0-15.5-6.939-15.5-15.5s6.94-15.5 15.5-15.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M268 216c3.314 0 6 2.686 6 6s-2.686 6-6 6c-3.313 0-6-2.686-6-6s2.687-6 6-6",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151678",
    d: "M279.76 9c-6.105 15.024-9.494 31.585-9.494 48.99 0 62.35 43.414 113.92 99.875 122.463 18.338 4.724 37.135 4.513 54.859-.076v5.665c0 1.628-1.251 2.958-2.783 2.958H288.822c-8.075-22.827-22.56-43.33-42.822-58.18V11.958C246 10.33 247.252 9 248.784 9h30.976z",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151678",
    d: "M384.24 9c6.105 15.024 9.494 31.585 9.494 48.99 0 62.35-43.414 113.92-99.875 122.463-18.338 4.724-30.135 4.59-47.859 0l1.9 5.28c0 1.628 11.569 3.267 13.1 3.267h114.178c8.075-22.827 22.56-43.33 42.822-58.18V11.958C418 10.33 416.748 9 415.216 9H384.24z",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000154",
    d: "M115.89 9h17.604c3.859 56.945 43.75 103.25 95.506 113.161v65.827c0 1.106-.85 2.012-1.89 2.012H115.89c-1.04 0-1.89-.906-1.89-2.012V11.013c0-1.108.85-2.013 1.89-2.013",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M44 195c.238 0 .476.005.713.012l7.923-.012c-.154.524-.38 1.008-.665 1.441C61.307 199.935 68 209.385 68 220.5c0 10.663-6.162 19.797-14.908 23.604.402.547.724 1.17.943 1.853l-8.753.006c-.424.023-.852.037-1.282.037-.422 0-.84-.013-1.257-.035h-.007C30.069 245.265 20 234.133 20 220.5c0-13.794 10.308-25.028 23.185-25.485v-.001h.047c.254-.009.51-.014.768-.014",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M52 195c13.255 0 24 11.417 24 25.5S65.255 246 52 246c-13.254 0-24-11.417-24-25.5S38.746 195 52 195",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91928E",
    d: "M52.5 206c7.456 0 13.5 6.716 13.5 15 0 8.284-6.044 15-13.5 15-7.455 0-13.5-6.716-13.5-15 0-8.284 6.045-15 13.5-15",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M53 215c3.314 0 6 2.91 6 6.5s-2.686 6.5-6 6.5c-3.313 0-6-2.91-6-6.5s2.687-6.5 6-6.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB622E",
    d: "M140.094 200H93.179c-3.003 0-5.423.855-6.817 2.248-1.381 1.377-1.772 3.296-.894 5.396.82 1.956 1.642 3.906 2.46 5.859.818 1.951 1.63 3.904 2.447 5.856.88 2.104 2.73 4.008 4.969 5.397 2.215 1.375 4.831 2.244 7.34 2.244h39.197c2.508 0 4.747-.867 6.391-2.244 1.655-1.386 2.728-3.293 2.728-5.397v-5.856-5.86c0-2.1-1.205-4.018-3.168-5.395-1.982-1.394-4.741-2.248-7.738-2.248",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7C148",
    d: "M127.707 66H215.47c2.486 0 4.527 3.285 4.527 7.306.002 20.298.002 40.583.002 60.867v60.853c0 .23-.008.46-.022.686v13.631c0 2.562-1.153 4.657-2.557 4.657h-6.355c-1.406 0-3.875-2.095-5.487-4.657l-4.423-7.026H122.485c-2.628 0-4.637-3.272-4.476-7.291.81-20.286 1.635-40.57 2.453-60.853.819-20.284 1.636-40.569 2.454-60.867.162-4.021 2.305-7.306 4.79-7.306",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E99A31",
    d: "M169.097 130.41l.308-.155c.286-.096.571-.191.856-.29 3.785-.82 7.481-1.904 11.07-3.23 12.633-1.908 24.392-6.703 34.669-13.735v65c-9.356-10.17-21.065-18.19-34.63-22.999-18.927-6.708-38.487-6.109-55.982.35l-.388.068.126-3.133c8.556-1.64 16.677-4.612 24.167-8.705 2.453-1.3 4.84-2.718 7.155-4.249 1.91-1.172 3.775-2.42 5.59-3.739 1.88-1.306 3.708-2.687 5.482-4.14.245-.189.489-.38.732-.571.282-.157.564-.314.845-.473",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E0",
    d: "M6.58 121h16.84c1.42 0 2.58 1.2 2.58 2.668v30.664C26 155.8 24.84 157 23.42 157H6.58C5.16 157 4 155.8 4 154.332v-30.664C4 122.2 5.16 121 6.58 121",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M2.582 121h16.837c1.42 0 2.581 1.2 2.581 2.668v30.664C22 155.8 20.84 157 19.42 157H2.581C1.162 157 0 155.8 0 154.332v-30.664C0 122.2 1.162 121 2.582 121",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M10.796 132h.235c.988 0 1.795.875 1.795 1.943v25.576l14.787 20.174c.614.838.483 2.066-.29 2.73l-.185.159c-.773.663-1.91.522-2.522-.315L9.66 161.861c-.402-.358-.66-.899-.66-1.502v-26.416c0-1.068.808-1.943 1.796-1.943",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3762B",
    d: "M26 145h101.676c.801 0 1.396.703 1.317 1.562l-4.973 54.877c-.078.858-.798 1.561-1.602 1.561H55.881c-3.036-3.326-6.3-6.41-9.766-9.227C43.93 175.301 36.722 158.503 26 145",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9E26B",
    d: "M139.19 197h-15.38c-1.546 0-2.81 1.327-2.81 2.95v16.1c0 1.623 1.264 2.95 2.81 2.95h15.38c1.546 0 2.81-1.327 2.81-2.95v-16.1c0-1.623-1.264-2.95-2.81-2.95",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M158.5 193c.273 0 .545.005.817.013l9.079-.013c-.176.597-.436 1.147-.762 1.64C178.331 198.613 186 209.362 186 222c0 12.127-7.06 22.513-17.082 26.844.46.622.829 1.33 1.08 2.107l-10.029.008c-.486.027-.976.041-1.47.041-.482 0-.963-.013-1.44-.04h-.008C142.537 250.165 131 237.505 131 222c0-15.687 11.81-28.462 26.566-28.982v-.002h.053c.293-.009.585-.016.88-.016",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M168.5 193c15.187 0 27.5 12.984 27.5 29s-12.313 29-27.5 29-27.5-12.984-27.5-29 12.313-29 27.5-29",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5592D",
    d: "M19.548 145h17.09c4.234 10.442 10.32 20.224 18.263 28.766C73.31 193.568 97.908 202.652 122 201.03l-.037.409c-.078.858-.794 1.561-1.594 1.561H14.32c-.8 0-1.39-.703-1.312-1.561l4.947-54.877c.079-.859.795-1.562 1.594-1.562",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC9134",
    d: "M41.564 66H135.866c2.67 0 4.507 2.072 4.07 4.61-2.206 12.805-4.412 25.602-6.615 38.4l-6.615 38.39c-.437 2.537-3.103 4.6-5.928 4.6H21.135c-2.824 0-4.626-2.064-4.016-4.6 3.075-12.797 6.167-25.595 9.25-38.39l9.253-38.4c.612-2.538 3.271-4.61 5.942-4.61",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEECB5",
    d: "M44.403 77h84.809c2.41 0 4.097 1.71 3.74 3.805-1.797 10.572-3.588 21.138-5.378 31.702s-3.579 21.13-5.367 31.694c-.355 2.095-2.711 3.799-5.24 3.799H27.772c-2.528 0-4.181-1.704-3.684-3.799 2.511-10.564 5.013-21.13 7.522-31.694 2.509-10.565 5.03-21.13 7.533-31.702.496-2.094 2.85-3.805 5.26-3.805",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M55.49 161h32.326c.7 0 1.232.547 1.18 1.214l-.12 1.573c-.051.667-.667 1.213-1.367 1.213H55.183c-.7 0-1.231-.546-1.18-1.213l.12-1.573c.052-.667.667-1.214 1.367-1.214M54.492 170h32.324c.7 0 1.231.545 1.18 1.214l-.12 1.572c-.052.668-.666 1.214-1.368 1.214H54.184c-.7 0-1.231-.546-1.18-1.214l.12-1.572c.051-.669.666-1.214 1.368-1.214M53.49 178h32.326c.7 0 1.232.546 1.18 1.214l-.12 1.572c-.051.669-.666 1.214-1.367 1.214H53.184c-.7 0-1.232-.545-1.18-1.214l.12-1.572c.051-.668.666-1.214 1.367-1.214M53.49 186h32.326c.7 0 1.231.546 1.18 1.214l-.12 1.572c-.052.668-.667 1.214-1.367 1.214H53.183c-.7 0-1.231-.546-1.18-1.214l.12-1.572c.052-.668.667-1.214 1.367-1.214",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M31.5 157c5.247 0 9.5 4.703 9.5 10.5 0 5.8-4.253 10.5-9.5 10.5s-9.5-4.7-9.5-10.5c0-5.797 4.253-10.5 9.5-10.5M110.5 156c5.247 0 9.5 4.7 9.5 10.5s-4.253 10.5-9.5 10.5-9.5-4.7-9.5-10.5 4.253-10.5 9.5-10.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BB4B",
    d: "M22.46 183h14.635c1.705 0 3.01 1.474 2.898 3.278l-.15 2.443c-.111 1.804-1.598 3.279-3.303 3.279H21.905c-1.705 0-3.01-1.475-2.898-3.279l.15-2.443c.111-1.804 1.597-3.278 3.303-3.278M101.46 183h14.635c1.705 0 3.01 1.474 2.898 3.278l-.15 2.443c-.11 1.804-1.597 3.279-3.302 3.279h-14.635c-1.706 0-3.01-1.475-2.9-3.279l.151-2.443c.111-1.804 1.598-3.278 3.303-3.278",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3762B",
    d: "M42.853 89H84.53c1.18 0 2.16 1.109 2.169 2.465.047 6.85.096 13.695.148 20.54.052 6.844.105 13.689.153 20.534.01 1.357-1.17 2.461-2.622 2.461H33.145c-1.452 0-2.39-1.105-2.089-2.46l4.553-20.535 4.56-20.54C40.467 90.11 41.671 89 42.852 89",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFA241",
    d: "M4.733 197h116.534c1.503 0 2.733 1.327 2.733 2.95v16.1c0 1.623-1.23 2.95-2.733 2.95H4.733C3.23 219 2 217.673 2 216.05v-16.1c0-1.623 1.23-2.95 2.733-2.95",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E3423",
    d: "M147.22 77H212.152c1.842 0 3.372 1.711 3.386 3.805.075 10.573.146 21.138.227 31.702.08 10.565.154 21.13.236 31.696.016 2.094-1.707 3.797-3.829 3.797h-74.844c-2.121 0-3.593-1.704-3.287-3.797 1.544-10.566 3.094-21.13 4.643-31.696 1.549-10.565 3.107-21.13 4.651-31.702.306-2.094 2.045-3.805 3.887-3.805",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M198.016 161h14.967c1.109 0 2.017.983 2.017 2.185v1.63c0 1.202-.908 2.185-2.017 2.185h-14.967c-1.108 0-2.015-.983-2.016-2.185v-1.63c0-1.202.908-2.185 2.016-2.185",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#411E16",
    d: "M173.926 99h34.998c3.906 0 6.6 3.36 5.99 7.468l-4.627 31.064c-.612 4.108-4.307 7.468-8.214 7.468h-34.998c-3.905 0-6.6-3.36-5.988-7.468l4.625-31.064c.612-4.108 4.308-7.468 8.214-7.468",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M138 124.98l4.807 12.02L157 134.766 155.884 118l-17.38 3.628-.504 3.352",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A653",
    d: "M145 130.334l1.436 5.666L157 134.019 155.193 124c-.568 2.461-1.986 4.537-3.917 5.738-1.931 1.2-4.204 1.415-6.276.596",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M129.463 122h16.073c1.355 0 2.464 1.2 2.464 2.668v30.664c0 1.467-1.109 2.668-2.464 2.668h-16.073c-1.355 0-2.463-1.2-2.463-2.668v-30.664c0-1.468 1.108-2.668 2.463-2.668",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M125.463 122h16.074c1.355 0 2.463 1.2 2.463 2.668v30.664c0 1.467-1.108 2.668-2.463 2.668h-16.074c-1.355 0-2.463-1.2-2.463-2.668v-30.664c0-1.468 1.108-2.668 2.463-2.668",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252327",
    d: "M154.953 133.02c.59 2.411 1.504 3.305 3.93 2.877l13.741-2.32c5.849-.96 9.973-6.108 9.305-11.616-.67-5.507-6.084-10.09-11.776-8.714l-16.307 3.798c-1.618.381-2.07 1.811-1.75 3.531l2.857 12.444",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M165 143.304c41.5 12.674 54.919 4.197 40.26-25.43 0 0-8.181-3.087-29.907-7.874-2.883.954-7.457 6.682-8.36 15.795L165 143.305",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25222A",
    d: "M199.014 118c15.814 31.115 8.142 38.807-23.014 23.076 3.644 1.868 7.946 1.393 11.166-1.234 3.218-2.627 4.573-6.867 4.156-11.269-.495-5.19 2.908-9.869 7.692-10.573",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M189.551 99c-5.587 1.74-10.704 5.404-12.16 11.76-1.66 6.811 2.12 12.24 8.521 12.24 6.402 0 13.094-5.429 15.088-12.24l-4.44-.06c-.19.322-.445.61-.764.834-.602.427-1.014.563-1.739.557-.434.346-.974.55-1.559.55h-.167c-.547.003-1.097-.178-1.568-.554l-.149-.117c-.433-.33-.765-.826-.933-1.364l-.07-.225-.113-.317c-.1-.286-.136-.534-.167-.833-.073-.256-.174-.498-.243-.756-.037-.135-.071-.271-.104-.405-.428-.52-.686-1.27-.686-1.962v-1.79c0-.388.084-.701.171-1.07l.06-.476.038-.447c.026-.297.108-.6.19-.893.032-.232.098-.449.158-.673.067-.248.174-.493.267-.731.108-.372.185-.684.37-1.028",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M188.848 103c-4.04 1.321-6.903 4.747-10.53 9.774-1.35 5.134 1.724 9.226 6.933 9.226 4.742 0 9.679-3.393 11.749-7.875-3.661.243-6.973-2.168-7.79-5.705-.076-.286-.137-.579-.18-.877-.045-.233-.08-.47-.103-.71-.11-.51-.165-1.027-.165-1.546 0-.763-.032-1.53.086-2.287",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A653",
    d: "M192.72 102.892c-1.39-2.699-5.631.727-12.72 10.278 2.552 2.982 6.518 3.688 9.744 1.734 2.345-1.202 4.337-1.428 5.97-.676.548-.974.98-2.029 1.286-3.132l-3.646-.055c-.382-3.132-.593-5.847-.633-8.15",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M192 90.974c-.485 14.197-6.493 18.334-18.025 12.41-1.114-3.728-1.273-7.42-.479-11.077 11.189-3.908 17.356-4.352 18.504-1.333",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161715",
    d: "M180 93c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1M174 93c.553 0 1 .448 1 1 0 .553-.447 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6783C",
    d: "M176.333 91.929c1.59-1.479 2.285-1.182 1.95.818l-.585 4.04c.624.108 1.121.582 1.262 1.203.142.62-.103 1.264-.618 1.633-.515.37-1.201.39-1.738.055-.44-.356-1.26-.249-2.46.322-3.329-.253-2.917-3.25 2.189-8.071",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A653",
    d: "M180.052 103.967c-.348-2.599 1.083-5.1 3.446-6.029 2.243-.71 2.95-3.71 1.2-5.404-1.116-1.28-1.096-2.396.061-3.351 4.503-.41 6.773-.13 6.813.838 1.834 9.622-2.267 14.431-11.52 13.946",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20211F",
    d: "M176.164 113c-2.13-.46-3.095-1.94-2.886-4.444.065-.761-.092-1.778-.536-3.132-.926-2.53-1.144-4.006.273-5.51 1.152-1.224 3.197-1.307 5.388.293 1.1.798 2.18 1.3 3.211 1.545.152 2.097 1.006 3.93 2.386 5.344-.152.4-.276.817-.367 1.247-.042.13-.081.26-.117.39-.135.318-.253.649-.351.991-.034.084-.063.17-.096.255-.06.129-.115.26-.168.394-.09.153-.174.309-.254.47-.465.151-.92.357-1.356.613-.29.098-.576.182-.863.288-.297.106-.593.234-.882.384-.403.092-.795.221-1.17.384-.313.08-.622.183-.924.31-.433.017-.864.075-1.288.178",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10110F",
    d: "M195.93 97.676c-1.123.534-1.912.9-1.357 1.417.719.654.975 1.718.642 2.66-.334.94-1.186 1.56-2.132 1.547-.565.008-.91.178-1.064.629-1.84 5.723-6.08 8.749-12.725 9.07-1.433.026-2.531-.227-3.294-.76 3.514-.413 6.248-3.582 6.248-7.431 0-.957-.17-1.873-.477-2.714 4.984 1.906 9.072-2.07 9.326-7.683.079-1.606-.408-2.253-1.46-1.94-1.37.356-2.78-.399-3.329-1.781L197.455 85c1.344.6 1.817 2.378.968 3.637-.36.542-.156.848.179 1.03 2.18 1.145 2.177 5.803-2.671 8.01",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M197.313 94.156c1.184.322 2.056 1.089 2.45 2.067.386.961.303 2.14-.264 3.304-.554 1.167-1.436 2.11-2.358 2.732-.9.607-1.849.894-2.709.66-.859-.235-1.514-.956-1.937-1.927-.433-.99-.628-2.23-.397-3.485.24-1.252.908-2.276 1.844-2.872.962-.613 2.187-.803 3.37-.479",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFA241",
    d: "M194.992 97.086c.445.18.771.605.919 1.149.145.534.113 1.189-.098 1.836-.208.647-.54 1.172-.885 1.517-.338.338-.693.497-1.016.367-.322-.131-.567-.532-.727-1.07-.162-.551-.234-1.24-.149-1.937.09-.696.342-1.264.692-1.595.36-.34.82-.446 1.264-.267",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M176.938 104.304c1.292-.665 2.304-.194 2.011.967-.244.853-1.178 1.518-2.372 1.687-1.195.17-2.415-.189-3.095-.91-.835-.873-.547-1.558.573-1.483 1.289.114 2.184.088 2.883-.26",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M172.11 82.417c5.256 4.495 13.886 4.761 25.89.796-.2-5.971-.945-12.878-12.36-14.107-9.156-.985-14.488 5.012-13.53 13.31",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776F82",
    d: "M180 84.808c4.523.592 10.189-.186 17-2.335-.115-3.293-.423-6.901-3.084-9.473-6.868 3.906-3.713 10.938-13.916 11.808",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M197.137 87.222c1.304-.749 1.892-1.42 1.862-1.874H199L198.949 84c-.738.433-1.124.762-1.16.986-.105.012-.216.026-.334.047-11.97 1.775-19.913 1.705-23.83-.211-.626-.282-1.299-.182-1.965.168l-6.93 3.703c-.433.23-.78.47-1.045.714-.197-.138-.453-.173-.685-.085l.047 1.242c-.003.057 0 .115.006.172v.003c.113.945 1.416 1.826 3.817 2.37 10.115 2.286 19.83.12 30.267-5.887",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776F82",
    d: "M185 83.592c-5.517.279-9.472-.197-11.862-1.427-.599-.285-1.244-.184-1.884.169l-6.64 3.737c-2.758 1.544-1.922 3.509 2.052 4.458.782.185 1.561.343 2.34.471.236-.043.472-.082.708-.119.613-.114 1.226-.209 1.842-.282.57-.112 1.145-.204 1.718-.293.212-.064.426-.127.64-.188.423-.138.853-.277 1.28-.406.457-.154.919-.295 1.382-.425l.187-.132c.491-.378.993-.74 1.503-1.082.502-.394 1.015-.769 1.536-1.124.478-.348.976-.69 1.472-1.013.61-.42 1.232-.813 1.862-1.18.612-.415 1.234-.804 1.864-1.164",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M196.251 85.247c2.188-1.338 2.363-2.547.297-2.18-3.79.598-7.149.986-10.076 1.163-11.571 2.582-7.543 6.847-19.472 6.62.289.094.6.182.934.263 9.464 2.276 18.551.118 28.317-5.866",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M206.916 125c11.76 33.27 3.12 39.76-25.916 19.47 3.392 2.4 7.744 2.573 11.291.447 3.547-2.127 5.443-6.134 5.595-10.569.174-5.228 4.17-9.365 9.03-9.348",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDE9B",
    d: "M202.362 139.978C210.488 135.884 217.2 134 217.2 134c1.132 5.668 1.6 9.246 1.6 9.246.521 4.85.141 8.545-2.558 11.378-2.483 2.607-5.692 4.235-9.943 2.898l-28.018-8.876c-1.442-.472-2.776-.865-4-1.178H162c.725-4.706 4.484-9.393 9.933-10.265 3.085-.534 6.205.108 9.646 2.33l20.725 5.165c1.959.486.74-1.648.058-4.72",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A653",
    d: "M208.204 138.429l8.024-4.429c1.157 6.008 1.55 9.054 1.55 9.054.593 4.606.024 7.318-2.039 9.674-3.176 3.626-4.718 3.658-7.388 2.833L199 152.566c9.433 1.495 11.42-2.63 11.01-8.365-.137-1.933-.74-3.943-1.806-5.772",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222025",
    d: "M216.407 136.799c2.232-.812 3-1.824 2.393-4.263l-3.343-13.834c-1.396-5.89-6.61-9.654-11.762-8.491-5.152 1.163-9.034 7.092-7.258 12.786l4.954 16.324c.497 1.62 1.887 1.957 3.487 1.48l11.53-4.002",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646169",
    d: "M214.718 132.656c-.096-2.128-.008-4.286.282-6.449l-1.564-6.992c-.753-3.433-2.839-6.066-5.38-7.215-4.037 4.954 5.396 16.72-3.056 27l8.963-3.361c.096-.438.201-.87.313-1.3.134-.568.282-1.128.442-1.683",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A2B",
    d: "M213.568 135.936c2.093-.69 2.814-1.548 2.244-3.619L213.324 123c.305 5.816-.156 11.926-6.324 15l6.568-2.064",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D86B2C",
    d: "M6.243 199h21.114c4.676 6.255 10.236 11.983 16.643 17H6.243C5.01 216 4 214.975 4 213.72v-12.44c0-1.254 1.01-2.28 2.243-2.28",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E0",
    d: "M167.5 207c8.56 0 15.5 6.939 15.5 15.5s-6.94 15.5-15.5 15.5c-8.56 0-15.5-6.939-15.5-15.5s6.94-15.5 15.5-15.5",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464644",
    d: "M168 216c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161050",
    d: "M319 189h-70.232c-1.523 0-2.768-1.338-2.768-2.975V124c35.187 15.74 20.164 53.416 66.676 62.788 2.082.802 4.19 1.538 6.324 2.212",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00029A",
    fillOpacity: 0.431,
    d: "M422.884 9h-6.77c-.062 0-.114.058-.114.128v177.745c0 .07.052.127.115.127h6.77c.063 0 .115-.057.115-.127V9.128c0-.07-.052-.128-.116-.128",
    transform: "translate(144 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M134.837 138h.25c1.052 0 1.913.823 1.913 1.83v24.877c0 .109-.01.217-.03.322-.05.406-.24.797-.57 1.1l-7.987 7.361c-.759.7-1.976.676-2.706-.048l-.174-.173c-.73-.724-.707-1.888.051-2.587l7.34-6.763V139.83c0-1.007.86-1.83 1.913-1.83",
    transform: "translate(144 153)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck.19da955c.svg";
export { ForwardRef as ReactComponent };